export const Spinner = () => {
  return (
    <div className="flex items-center justify-center">
      <div className="w-6 h-6 border-4 border-gray-300 border-t-[#059985] rounded-full animate-spin" />
    </div>
  );
};
